import { Route, Routes, useLocation, useNavigate } from "react-router-dom"
import UserDashboard from "./screens/user/UserDashboard"
import { useContext, useEffect, useState } from "react"
import UserNav from "./components/user/UserNav"
import Header from "./components/Header"
// import UserSettings from "./screens/user/UserSettings"
import { AppContext } from "./context/AppContext"
import Settings from "./screens/Settings"

const User = () => {

    const { loggedIn, setLoggedIn } = useContext(AppContext)

    const location = useLocation()
    const Navigate = useNavigate()

    const [headerTitle, setHeaderTitle] = useState('')
    const [expandedNav, setExpandedNav] = useState(false)

    const handleTitleChange = () => {
        switch (location.pathname) {
            case '/user/dashboard':
                setHeaderTitle('Dashboard')
                break;

            case '/user/settings':
                setHeaderTitle('Settings')
                break;

            default:
                setHeaderTitle('User')
                break;
        }
    }

    useEffect(() => {
        if (!loggedIn) {
            Navigate('/login')
        }
    }, [loggedIn, Navigate])

    useEffect(() => {
        handleTitleChange()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname])

    return (
        <div className=" w-full h-screen md:flex relative">
            <UserNav expandedNav={expandedNav} setExpandedNav={setExpandedNav} />

            <div onClick={() => setExpandedNav(false)} className={`${expandedNav ? " block" : " hidden"} md:hidden fixed w-screen h-screen z-10`}></div>

            <div className=" h-full overflow-y-auto overflow-x-hidden md:flex-1 scrollbar relative">
                <Header setExpandedNav={setExpandedNav} title={headerTitle} setLoggedIn={setLoggedIn} />
                <Routes>
                    <Route element={<UserDashboard />} path="/dashboard" />
                    {/* <Route element={<UserSettings />} path="/settings" /> */}
                    <Route element={<Settings userType={'User'} />} path="/settings" />
                </Routes>
            </div>
        </div>
    )
}

export default User